import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import SeoMeta from "./components/SeoMeta";
import AnalyticsTracker from "./components/AnalyticsTracker";

function App() {
  return (
    <BrowserRouter>
      <SeoMeta />
      <AnalyticsTracker />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
